import { FormInput, Grid } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="E-mail"
      description={`Typ hieronder uw E-mail adres (indien correct druk op "volgende")`}
    >
      <Grid container spacing={4}>
        <FormInput
          name="email"
          label="E-mail"
          type="email"
          placeholder="Vul je e-mail adres in"
          xs={12}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
